import { clx } from "@modules/common/components/ui"

// Solid five-point star (heroicons mini path), filled via currentColor.
export const StarIcon = ({ className }: { className?: string }) => (
  <svg
    viewBox="0 0 20 20"
    fill="currentColor"
    aria-hidden="true"
    className={clx("shrink-0", className)}
  >
    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.958a1 1 0 00.95.69h4.162c.969 0 1.371 1.24.588 1.81l-3.367 2.446a1 1 0 00-.363 1.118l1.286 3.958c.3.921-.755 1.688-1.539 1.118l-3.367-2.446a1 1 0 00-1.175 0l-3.367 2.446c-.783.57-1.838-.197-1.539-1.118l1.286-3.958a1 1 0 00-.363-1.118L2.063 9.385c-.783-.57-.38-1.81.588-1.81h4.162a1 1 0 00.95-.69l1.286-3.958z" />
  </svg>
)

type StarRatingProps = {
  // 0-5, fractional values render partially filled stars.
  rating: number
  // Tailwind size classes applied to each star.
  size?: string
  className?: string
}

// Amber stars filled proportionally to the rating: a gray base row with an
// amber overlay clipped to the rating percentage, so averages like 4.3
// render a partial fifth star.
const StarRating = ({
  rating,
  size = "h-4 w-4",
  className,
}: StarRatingProps) => {
  const pct = Math.max(0, Math.min(100, (rating / 5) * 100))

  return (
    <span
      className={clx("relative inline-flex", className)}
      role="img"
      aria-label={`Rated ${rating} out of 5 stars`}
    >
      <span className="flex text-gray-300" aria-hidden="true">
        {[1, 2, 3, 4, 5].map((i) => (
          <StarIcon key={i} className={size} />
        ))}
      </span>
      <span
        className="absolute inset-y-0 left-0 flex overflow-hidden text-amber-400"
        style={{ width: `${pct}%` }}
        aria-hidden="true"
      >
        {[1, 2, 3, 4, 5].map((i) => (
          <StarIcon key={i} className={size} />
        ))}
      </span>
    </span>
  )
}

export default StarRating
